<template>
    <div v-if="!requisicoes.finalizado" class="loading-overlay">
        <div class="spinner"></div>
    </div>
    <div v-if="requisicoes.finalizado">
        <div class="title" v-if="!Edicao">
            <div style="display: inline-flex; width: 100%">
                <div style="width: 30%;" v-if="dadosUsuario.PerfilRisco == ''">
                    <h3>Descubra agora seu perfil investidor</h3>
                    <h5>Caso queira, você poderá salvar e continuar depois.</h5>
                </div>
                <div style="width: 30%;" v-if="dadosUsuario.PerfilRisco != ''">
                    <h3>Resultado: {{ dadosUsuario.PerfilRisco }}</h3>
                </div>
                <div v-if="!Edicao" style="width: 40%; padding-top: 40px;">
                    <button v-if="dadosUsuario.PerfilRisco == ''" class="btnBlue" style="cursor: pointer;"
                        @click="abrirQuestionario()">Preencher questionário</button>
                    <button v-if="dadosUsuario.PerfilRisco != ''" class="btnBlue" style="cursor: pointer;"
                        @click="abrirQuestionario()">Refazer questionário</button>
                </div>
            </div>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario" v-if="!bloquearDispensaQuestionario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dispensa de questionário'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Produtos'" :SubSessao="'Dispensa do questionário'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="password">Dispensar questionário?*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="DispensarQuestionario"
                                    class="field__radio" @change="abrirModalDispensa" v-model="dispensar" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="DispensarQuestionario"
                                    class="field__radio" @change="abrirModalDispensa" v-model="dispensar" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                        <div class="label__field" style="width: 30%" v-if="dispensar == 'true' || dispensar == true">
                            <label class="label" for="confirmarPassword">Motivo da dispensa do questionário*</label>
                            <div>
                                <select style="width: 110% !important;" id="motivoDispensaQuestionario"
                                    @change="alterarDispensa"
                                    v-model="dispensaQuestionario.MotivoDispensaQuestionarioId" class="field">
                                    <option value="">Selecione</option>
                                    <option v-for="item in listaMotivosDispensa" :key="item.Id" :value="item.Id">
                                        {{ item.Descricao }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.nomeEmpresa != 'ACTUAL' || (this.nomeEmpresa == 'ACTUAL' && this.Edicao == true)">
            <div class="title">
                <h3>Produtos</h3>
                <h5>Preencha o questionário Suitability para ter acesso aos melhores produtos de acordo com o seu
                    perfil.</h5>
            </div>
            <div v-if="listaProdutos?.length > 0">
                <table class="table">
                    <thead>
                        <th style="width: 30%">Nome do produto</th>
                        <th style="width: 20%">CNPJ</th>
                        <th style="width: 15%">Perfil</th>
                        <th style="width: 15%">Vigência</th>
                        <th style="width: 20%">Ações</th>
                    </thead>
                    <tbody>
                        <tr v-for="(produto, index) in produtosFiltrados" :key="index">
                            <td>{{ produto.Descricao }} </td>
                            <td>{{ produto.Cnpj != null ? formatCpfCnpj(produto.Cnpj) : '' }} </td>
                            <td>{{ produto.PerfilNome }}</td>
                            <td>{{ produto.Vigencia > 0 ? produto.Vigencia : 'Não se aplica' }}</td>
                            <td>
                                <div class="widget icons produtos" style="display: inline-flex">
                                    <button class="btnBlue"
                                        v-if="(!listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true) && this.nomeEmpresa != 'ACTUAL')"
                                        @click="lerTermos(produto.ProdutoId)">Ler os termos</button>

                                    <button class="btnBlue"
                                        v-if="(!listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true) && this.nomeEmpresa == 'ACTUAL')"
                                        @click="lerTermos(produto.ProdutoId)">Pendente de assinatura</button>

                                    <button class="btnBlue"
                                        style="cursor: pointer; background-color: #5E84C3; font-size: smaller; border-color: white;"
                                        v-if="listaProdutosCliente.some(p => p.ProdutoId == produto.ProdutoId && p.Aceite == true)"
                                        disabled="disabled">Produto Adquirido</button>

                                    <button class="btnDefault"
                                        v-if="listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true)"
                                        @click="visualizarTermos(produto.ProdutoId)">Ver mais</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <ModalQuestionario />
        <ModalProdutos />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalQuestionario from '../Questionario/ModalQuestionario.vue'
import ModalProdutos from '../Produtos/ModalInformativoProdutos.vue'
import formatCpfCnpj from '@/utils/formatCpfCnpj'

export default {
    name: 'CadastroPF_Produtos',
    props: ['Edicao'],
    mixins: [formatCpfCnpj],
    components: { ModalQuestionario, ModalProdutos },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaProdutos: 'GET_LISTA_PRODUTOS',
            listaProdutosCliente: 'GET_LISTA_PRODUTOS_CLIENTE',
            perfilCliente: 'GET_PERFIL_CLIENTE',
            listaMotivosDispensa: 'GET_LISTA_MOTIVO_DISPENSA',
            infoObjDispensa: 'GET_PF_PJ_SALVAR_INFO_DISPENSA',
            infoDispensaQuestionario: 'GET_PF_PJ_INFO_DISPENSA_QUESTIONARIO',
            configDispensaQuestionario: 'GET_DISPENSA_QUESTIONARIO',
            perfilSuitabilityPreview: 'GET_SUITABILITY_PREVIEW',

        }),
        produtosFiltrados() {
            if (this.nomeEmpresa != 'ACTUAL') {
                return this.listaProdutos;
            } else if (this.nomeEmpresa == 'ACTUAL' && !this.Edicao) {
                return [];
            } else if (this.nomeEmpresa == 'ACTUAL' && this.Edicao) {
                return this.listaProdutos.filter(produto =>
                    this.listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId)
                )
            } else {
                return [];
            }
        },
    },
    data() {
        return {
            requisicoes: {
                listaProdutos: false,
                perfilCliente: false,
                listaProdutosCliente: false,
                configDispensaQuestionario: false,
                finalizado: false
            },
            bloquearDispensaQuestionario: false,
            nomeEmpresa: '',
            dispensarAnterior: false,
            dispensar: false,
            dispensaQuestionario: {
                MotivoDispensaQuestionarioId: '',
                DataQuestionario: null
            },
            filtroPerfilNome: '',
            permitirAvancar: true,
            produtosCliente: [],
            dadosUsuario: {
                PerfilRisco: ''
            },
        }
    },
    created() {
        if(!this.Edicao){
            this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE');
        }

        this.$store.dispatch('FETCH_PERFIL_CLIENTE');
        this.$store.dispatch('FETCH_BUSCA_LISTA_MOTIVO_DISPENSA');
        this.$store.dispatch('FETCH_VERIFICAR_DISPENSA_QUESTIONARIO');
    },
    mounted() {
        this.$store.dispatch('FETCH_DISPENSA_QUESTIONARIO');
        this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
        this.$store.commit("SET_PERFIL_CLIENTE", null);

        this.verificarConfigDispensaQuestionario();
        this.verificarSeRequisicoesFinalizaram('listaProdutosCliente');
        if (this.listaProdutosCliente != null) {
            this.produtosCliente = this.listaProdutosCliente;
        }
        this.verificarSeRequisicoesFinalizaram('listaProdutos');
        this.verificarPerfilCliente();
        this.verificarConfigDispensaQuestionario();

        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        if (this.infoObjDispensa == null) {
            this.dispensaQuestionario = this.infoDispensaQuestionario;
            if (this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0) {
                this.dispensar = true;
            }
        }

    },
    watch: {
        perfilSuitabilityPreview(){
            this.obterProdutos();
        },
        configDispensaQuestionario() {
            this.verificarConfigDispensaQuestionario();
        },
        infoDispensaQuestionario() {
            this.dispensaQuestionario = this.infoDispensaQuestionario;
            if (this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0) {
                this.dispensar = true;
            }
        },
        listaProdutosCliente() {
            this.verificarSeRequisicoesFinalizaram('listaProdutosCliente');
            this.produtosCliente = this.listaProdutosCliente;
        },
        listaProdutos() {
            this.verificarSeRequisicoesFinalizaram('listaProdutos');
        },
        perfilCliente() {
            this.verificarPerfilCliente();
        }
    },
    methods: {
        obterProdutos(){
            if(this.perfilSuitabilityPreview?.Id > 0){
                this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_PREVIEW', this.perfilSuitabilityPreview?.Id);
            }else{
                this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS');  
            }
            this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE');
        },
        verificarPerfilCliente(){
            this.verificarSeRequisicoesFinalizaram('perfilCliente');
            if (this.perfilCliente)
                if (this.perfilCliente[0]) {
                    this.dadosUsuario = this.perfilCliente[0];
                    this.filtroPerfilNome = this.perfilCliente[0].PerfilRisco;

                    this.obterProdutos();
                } else {
                    this.filtroPerfilNome = '';
                    this.dadosUsuario = {
                        PerfilRisco: ''
                    };
                    this.$store.commit('SET_LISTA_PRODUTOS', [])
                    this.$store.commit('SET_LISTA_PRODUTOS_CLIENTE', [])
                }
        },
        verificarConfigDispensaQuestionario(){
            this.verificarSeRequisicoesFinalizaram('configDispensaQuestionario');
            if (this.configDispensaQuestionario != null) {
                var configuracaoDispensa = this.configDispensaQuestionario.filter(config =>
                    config.Chave == 'Dispensa do questionário'
                );
                if (configuracaoDispensa[0] != null) {
                    if (configuracaoDispensa[0].Valor == 'Não') {
                        this.bloquearDispensaQuestionario = true;
                    }
                }
            }
        },
        verificarSeRequisicoesFinalizaram(requisicao) {
            if (requisicao == 'listaProdutos' || this.nomeEmpresa == 'ACTUAL') {
                this.requisicoes.listaProdutos = true;
            } else if (requisicao == 'perfilCliente') {
                this.requisicoes.perfilCliente = true;
            } else if (requisicao == 'listaProdutosCliente') {
                this.requisicoes.listaProdutosCliente = true;
            } else if (requisicao == 'configDispensaQuestionario') {
                this.requisicoes.configDispensaQuestionario = true;
            }
            if ((this.requisicoes.listaProdutos && this.requisicoes.perfilCliente && this.requisicoes.listaProdutosCliente && this.requisicoes.configDispensaQuestionario) || this.nomeEmpresa == 'ACTUAL') {
                this.requisicoes.finalizado = true;
            }
        },
        abrirModalDispensa() {
            if (this.dispensarAnterior != this.dispensar && this.dispensar == "false") {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Remover dispensa de questionário',
                    text: 'Para realizar essa operação os produtos aderidos serão cancelados. Deseja seguir?',
                    showCancelButton: true,
                    confirmButtonText: 'Confirmar',
                    cancelButtonText: 'Cancelar',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.alterarDispensa();
                    } else {
                        this.dispensar = this.dispensarAnterior;
                    }
                });
            } else {
                this.alterarDispensa();
            }
        },
        alterarDispensa() {
            this.dispensarAnterior = this.dispensar;
            if (this.dispensar == "false" || (this.dispensar && this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0)) {
                if (this.dispensar == "false") {
                    this.dispensaQuestionario.MotivoDispensaQuestionarioId = '0';
                }
                this.salvarAlteracoesLocalmente();
                this.salvarInformacoes();
            } else {
                this.salvarAlteracoesLocalmente();
            }
        },
        abrirQuestionario() {
            this.$store.commit("SET_MODAL_QUESTIONARIO", true);
        },
        lerTermos(id) {
            this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
        },
        visualizarTermos(id) {
            this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", true);
        },
        validarFormulario() {
            var mensagemAlerta = 'Para a conclusão do cadastro, é necessário o preenchimento do questionário ou a dispensa do questionário.'
            if (this.bloquearDispensaQuestionario) {
                mensagemAlerta = 'Para a conclusão do cadastro, é necessário o preenchimento do questionário';
            }

            if (this.dadosUsuario.PerfilRisco == '' && !(this.perfilSuitabilityPreview?.Id > 0)) {

                this.$swal({
                    icon: 'error',
                    title: 'Concluir cadastro',
                    text: mensagemAlerta,
                });
                this.permitirAvancar = false;

            } else {
                this.permitirAvancar = true;
            }

            return this.permitirAvancar;
        },
        proximaEtapa() {
            if (this.validarFormulario()) {
                this.$store.commit('SET_FICHA_CONCLUIR', true);
                this.salvarInformacoes();
            }
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_PJ_SALVAR_INFO_DISPENSA', this.dispensaQuestionario);
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
    }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');


.formulario {
    width: 100%;
}

.produtos .btnBlue {
    height: 40px;
    font-family: 'Inter', sans-serif;
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C;
    border-radius: 8px;
    cursor: pointer;
}

.produtos .btnDefault {
    margin-left: 5px;
    height: 40px;
    font-family: 'Inter', sans-serif;
    background-color: white;
    color: black;
    border: 1px solid black;
    border-radius: 8px;
    cursor: pointer;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }
}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            border: 1px solid #D0D5DD;
            padding: 10px 14px;
            background-color: #F9FAFB;
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }

    label {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #344054;
        display: block;
        margin-bottom: 8px;
    }
}

.title {

    border-bottom: 1px solid #EAECF0;
    margin-bottom: 10px;

    .btnBlue {
        height: 40px;
        font-family: 'Inter', sans-serif;
        background-color: #00235C;
        color: white;
        border: 1px solid #00235C;
        border-radius: 8px;
    }

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>